export default class MobileMenu {
  constructor () {
    this.burger = document.querySelector('.navbar-burger')
    this.menu = document.querySelector('.navbar-menu')
    this.items = document.querySelectorAll('.navbar-end > .navbar-item')
    this.init()
  }

  toggleMenu () {
    this.burger.classList.toggle('is-active')
    this.menu.classList.toggle('is-active')
  }

  init () {
    // Hide the burger if the menu doesn't have items
    if (!this.items.length) {
      this.burger.style.display = 'none'
      return
    }

    // Toggle the menu after clicking the burger, or an item
    this.burger.addEventListener('click', () => this.toggleMenu())
    this.menu.addEventListener('click', () => this.toggleMenu())
  }
}
